import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import {
  fetchHealthCheckupComparison, fetchHealthCheckupDetailsBySlug, fetchHealthCheckupDetails,
  submitHealthCheckupForm, sendHealthCheckupToCRM
} from "../Adapter/PageAdapter";
import { Tabs, Tab, Box, Dialog, TextField, Button, CircularProgress } from "@mui/material";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { Toaster, toast } from 'sonner';
import bannerImg from "../assets/images/careerdetailban.jpg";
import rightTick from "../assets/images/healthcheckup/righttick.svg";
import arrowImg from "../assets/images/arrw.svg";
import { baseImage_path } from "../variables/Variables";

const HealthCheckupComparison = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [ids, setIds] = useState(location.state?.ids || []);
  const [comparisonData, setComparisonData] = useState([]);
  const { id, slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [healthCheckup, setHealthCheckup] = useState(null);
  const [healthPackages, setHealthPackages] = useState([]);
  const [removedTests, setRemovedTests] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    appointmentDate: "",
    message: "",
  });
  const [activeTab, setActiveTab] = useState(0);

  console.log("Location state: ", location.state);

  // Fetch comparison data
  useEffect(() => {
    const fetchComparisonData = async () => {
      if (ids.length < 2) {
        alert("You need at least two packages to compare.");
        navigate("/health-checkup");
        return;
      }

      try {
        const response = await fetchHealthCheckupComparison(ids);
        if (response && response.data) {
          setComparisonData(response.data);
        } else {
          alert("Failed to fetch comparison data.");
          navigate("/health-checkup");
        }
      } catch (error) {
        console.error("Error fetching comparison data:", error);
        alert("An error occurred while fetching comparison data.");
        navigate("/health-checkup");
      } finally {
        setLoading(false);
      }
    };

    fetchComparisonData();
  }, [ids, navigate]);

  // const handleRemovePackage = (id) => {
  //   const updatedIds = ids.filter((pkgId) => pkgId !== id);
  //   setIds(updatedIds);

  //   setComparisonData((prevData) =>
  //     prevData.filter((pkg) => pkg.checkup_id !== id)
  //   );

  //   if (updatedIds.length < 2) {
  //     alert("You need at least two packages to compare.");
  //     navigate("/health-checkup");
  //   }
  // };

  const handleRemovePackage = (id) => {
    const updatedIds = ids.filter((pkgId) => pkgId !== id);
    setIds(updatedIds);

    setComparisonData((prevData) =>
      prevData.filter((pkg) => pkg.checkup_id !== id)
    );

    // Mark tests for this package as removed
    setRemovedTests((prev) => [...prev, id]);

    if (updatedIds.length < 2) {
      alert("You need at least two packages to compare.");
      navigate("/health-checkup");
    }
  };

  useEffect(() => {
    const fetchDetails = async () => {
      try {

        const response = await fetchHealthCheckupDetailsBySlug(slug);
        if (response && response.data) {
          setHealthCheckup(response.data); // Set the details of the health checkup directly if it's an object
        } else {
          console.error("No health checkup details found for Slug:", slug);
        }
      } catch (error) {
        console.error("Error fetching health checkup details:", error);
      }
    };
    fetchDetails();
  }, [slug]);

  useEffect(() => {
    const fetchHealthCheckups = async () => {
      try {
        const response = await fetchHealthCheckupDetails();
        if (response && response.data) {
          setHealthPackages(response.data);
        }
      } catch (error) {
        console.error("Error fetching health checkup details:", error);
      }
    };

    fetchHealthCheckups();
  }, []);

  const handleOpen = (pkg) => {
    setFormData(prev => ({
      ...prev,
      health_checkup_package_id: pkg.checkup_id,
      packageName: pkg.checkup_title
    }));
    setOpen(true); // This triggers the modal to open
  };

  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.appointmentDate) {
      toast.error("Please select a valid appointment date and time.", { position: "top-center" });
      return;
    }

    setLoading(true);

    // Prepare payload object
    const payload = {
      health_checkup_package_id: formData.health_checkup_package_id,
      full_name: formData.name,
      phone: formData.phone,
      email: formData.email,
      appointment_date: formData.appointmentDate,
      message: formData.message
    };

    try {
      const response = await submitHealthCheckupForm(payload);

      if (response?.message) {
        await sendHealthCheckupToCRM(formData);

        toast.success(response.message, { position: "top-center" });
        handleClose(); // Close the modal on success

        // Reset form state
        setFormData({
          name: "",
          phone: "",
          email: "",
          appointmentDate: "",
          message: "",
          packageName: "",
          health_checkup_package_id: ""
        });
      }
    } catch (error) {
      toast.error("Failed to submit the form. Please try again.", { position: "top-center" });
    } finally {
      setLoading(false); // Stop the loader
    }
  };

  if (loading) {
    return <p>Loading comparison data...</p>;
  }

  // Grouping test_master_name to prevent duplication
  // const groupedTests = comparisonData[0]?.test_master?.reduce((acc, category) => {
  //   let existingCategory = acc.find((item) => item.test_master_id === category.test_master_id);
  //   if (existingCategory) {
  //     existingCategory.test_inclusion = [
  //       ...existingCategory.test_inclusion,
  //       ...category.test_inclusion
  //     ];
  //   } else {
  //     acc.push({ ...category });
  //   }
  //   return acc;
  // }, []);

  const groupedTests = comparisonData.reduce((acc, pkg) => {
    pkg.test_master?.forEach((category) => {
      const existingCategory = acc.find((item) => item.test_master_id === category.test_master_id);

      if (existingCategory) {
        // Merge test inclusions and avoid duplicates
        category.test_inclusion.forEach((test) => {
          if (!existingCategory.test_inclusion.some(t => t.test_inclusion_id === test.test_inclusion_id)) {
            existingCategory.test_inclusion.push(test);
          }
        });
      } else {
        acc.push({
          test_master_id: category.test_master_id,
          test_master_name: category.test_master_name,
          test_inclusion: [...category.test_inclusion]
        });
      }
    });
    return acc;
  }, []);

  return (
    <>
      {/* Banner Section */}
      <section className="banner-spac">
        <div className="cust-container">
          <div className="banner-box">
            <img src={bannerImg} alt="Health Checkup Packages" />
            <div className="ban-con">
              <h1>Health Check Up Packages Comparison</h1>
            </div>
          </div>
        </div>
      </section>

      <Toaster position="top-right" />

      {/* Test Names Section */}
      <section className="testnames-sec">
        <div className="cust-container">
          <div className="testname-sec-inner">
            <div className="testname-item-list">
              {/* {comparisonData.map((pkg) => (
                <div key={pkg.checkup_id} className="testname-items">
                  <div className="testitem-img">
                    <img
                      src={
                        pkg.checkup_image
                          ? `${baseImage_path}/${pkg.checkup_image}`
                          : `${baseImage_path}/images/health_checkups/default.jpg`
                      }
                      alt={pkg.checkup_title}
                    />
                    <button onClick={() => handleRemovePackage(pkg.checkup_id)}>X</button>
                  </div>
                  <div className="testitem-desc">
                    <h5>{pkg.checkup_title}</h5>
                    <span>Rs. {pkg.checkup_fees}/-</span>
                  </div>
                </div>
              ))} */}
            </div>
          </div>
        </div>
      </section>

      <section className="health-compare-table mrgntop70 margnbot90">
        <div className="cust-container">
          <div className="health-compare-table-inner">
            <table>
              <thead>
                <tr>
                  <th>
                    <div className="testname-head">
                      <p>Tests Names</p>
                    </div>
                  </th>
                  {comparisonData.map((pkg) => (
                    <th key={pkg.checkup_id}>
                      <div className="testname-items">
                        <div className="testitem-img">
                          <img
                            src={
                              pkg.checkup_image
                                ? `${baseImage_path}/${pkg.checkup_image}`
                                : `${baseImage_path}/images/health_checkups/default.jpg`
                            }
                            alt={pkg.checkup_title}
                          />
                          <button onClick={() => handleRemovePackage(pkg.checkup_id)}>X</button>
                        </div>
                        <div className="testitem-desc">
                          <h5>{pkg.checkup_title}</h5>
                          <span>Rs. {pkg.checkup_fees}/-</span>
                          <div className="jdapplybtn">
                            <a href="#" className="btn with-color with-arr" onClick={() => handleOpen(pkg)}>
                              <img src={arrowImg} alt="Arrow" />Book Now</a>
                          </div>
                        </div>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              {/* 
              <tbody>
                {groupedTests?.map((category, catIndex) => (
                  <React.Fragment key={catIndex}>
                    <tr>
                      <th>
                        <h5>{category.test_master_name}</h5>
                      </th>
                      {comparisonData.map(() => (
                        <td key={Math.random()}></td>
                      ))}
                    </tr>
                    {category.test_inclusion.map((test, testIndex) => (
                      <tr key={testIndex}>
                        <td>
                          <p>{test.test_inclusion_name}</p>
                        </td>
                        {comparisonData.map((pkg) => (
                          <td key={pkg.checkup_id}>
                            {pkg.test_master.some(
                              (master) =>
                                master.test_master_id === category.test_master_id &&
                                master.test_inclusion.some(
                                  (includedTest) => includedTest.test_inclusion_id === test.test_inclusion_id
                                )
                            ) ? (
                              <img src={rightTick} alt="Right Tick" /> // Display Right Tick if available
                            ) : (
                              <span>❌</span> // Display Cross if not available
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody> */}

              <tbody>
                {groupedTests?.map((category, catIndex) => (
                  <React.Fragment key={catIndex}>
                    <tr>
                      <th>
                        <h5>{category.test_master_name}</h5>
                      </th>
                      {comparisonData.map((pkg) => (
                        <td key={pkg.checkup_id}></td>
                      ))}
                    </tr>

                    {category.test_inclusion.map((test, testIndex) => (
                      <tr key={testIndex}>
                        <td>
                          <p>{test.test_inclusion_name}</p>
                        </td>
                        {comparisonData.map((pkg) => (
                          <td key={pkg.checkup_id}>
                            {pkg.test_master.length === 0 ||
                              !pkg.test_master.some(
                                (master) =>
                                  master.test_master_id === category.test_master_id &&
                                  master.test_inclusion.some(
                                    (includedTest) =>
                                      includedTest.test_inclusion_id === test.test_inclusion_id
                                  )
                              ) ? (
                              <span>❌</span> // Show cross if no tests or test is missing
                            ) : (
                              <img src={rightTick} alt="Right Tick" />
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>

            </table>
          </div>
        </div>
      </section>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <form onSubmit={handleSubmit}>
          <Box p={3}>
            <h3>Book Now - {formData.packageName || ""}</h3>

            <TextField
              fullWidth
              label="Full Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              margin="normal"
              required
            />

            <TextField
              fullWidth
              label="Phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              margin="normal"
              required
            />

            <TextField
              fullWidth
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              margin="normal"
              required
            />

            <TextField
              fullWidth
              label="Appointment Date & Time"
              name="appointmentDate"
              type="datetime-local"
              value={formData.appointmentDate}
              onChange={handleChange}
              margin="normal"
              required
              InputLabelProps={{ shrink: true }}
              inputProps={{
                min: new Date().toISOString().slice(0, 16),
                max: new Date(new Date().setDate(new Date().getDate() + 30)).toISOString().slice(0, 16)
              }}
            />

            <TextField
              fullWidth
              label="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              margin="normal"
              multiline
              rows={3}
            />

            <Box mt={2} display="flex" justifyContent="flex-end">
              <Button
                onClick={handleClose}
                style={{ marginRight: "8px" }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : "Submit"}
              </Button>
            </Box>
          </Box>
        </form>
      </Dialog>
    </>
  );
};

export default HealthCheckupComparison;
